import config from "./config";
import apiService from "./apiService";
export default {
  async save(payload) {
    let saveUserEventApiUrl = `${config.saveUserEventApiUrl}`;
    return apiService.post(saveUserEventApiUrl, payload);
  },

  async saveUserSession(payload) {
    let saveUserSessionApiUrl = `${config.saveUserSessionApiUrl}`;
    return apiService.post(saveUserSessionApiUrl, payload);
  },
};
